import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import SiteHeader from './SiteHeader';

function PageLayout({ children }) {
    return (
        <Box>
            <CssBaseline />
            <SiteHeader />
            <Box component="main" sx={{ flexGrow: 1, width: '100%' }}>
                {children}
            </Box>
        </Box>
    );
}

export default PageLayout;
